module.exports = __webpack_public_path__ + "img/doctor_white.ae85d0cc.svg";